'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = {
  root: (marginLeft, marginRight) => react.css(Object.assign(Object.assign({}, styleMixins_reset.boxSizing), {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft,
    marginRight
  }))
};
const InteractiveTagIcon = ({ "aria-hidden": ariaHidden = true, "aria-label": ariaLabel, name, position }) => {
  const calculateLeftMargin = () => {
    if (name === "formX") {
      return position === "before" ? "-5px" : "0px";
    }
    return "0px";
  };
  const calculateRightMargin = () => {
    if (name === "formX") {
      return position === "after" ? "-5px" : "0px";
    }
    return "0px";
  };
  return react.jsx(
    "div",
    { css: Styles.root(calculateLeftMargin(), calculateRightMargin()), "data-zds": true },
    react.jsx(components_display_Icon_Icon.Icon, { "aria-hidden": ariaHidden, "aria-label": ariaLabel, name, size: 24 })
  );
};

exports.InteractiveTagIcon = InteractiveTagIcon;
//# sourceMappingURL=InteractiveTagIcon.cjs.js.map
